import { QuestionDeleteEndpoint } from '@core/types/types.endpoint.question';
import { useDisclosure } from '@frontend/hooks/use-disclosure';
import { ConfirmDialog } from '@frontend/shared/components/ConfirmDialog/ConfirmDialog';
import { useBroadcaster } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';

export function useDeleter(id: string, callback?: () => void) {
  const confirmer = useDisclosure();
  const broadcast = useBroadcaster();

  const deleter = useSubmitter(async () => {
    const [err, res] = await callApi<QuestionDeleteEndpoint>(
      '/question/delete',
      {
        id,
      },
    );

    if (err || !res) return new Error(err?.error);

    callback?.();

    broadcast({
      event: 'question:delete',
      questionId: res.id,
    });
  });

  const title = `Delete question`;
  const description = `Are you sure you want to delete this question?`;

  return {
    isDeleting: deleter.isSubmitting,
    confirmer: (
      <ConfirmDialog
        onClose={confirmer.onClose}
        isOpen={confirmer.isOpen}
        title={title}
        description={description}
        onSuccess={deleter.submit}
      />
    ),
    onConfirmDelete: confirmer.onOpen,
    forceDelete: deleter.submit,
  };
}
